import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import Layout from '../layout';
import Localization from '../../utils/localization';
import BugsnagErrorBoundary from '../../../utils/bugsnug';
import { buildStore } from '../../redux/config/store';
import WebAttribution from '../../utils/web_attribution';

const store = buildStore();

function AppWrapper({ children }) {
  return (
    <BugsnagErrorBoundary>
      <Provider store={ store }>
        <Localization />
        <WebAttribution />
        <Layout>
          {children}
        </Layout>
      </Provider>
    </BugsnagErrorBoundary>
  );
}

AppWrapper.propTypes = {
  children: PropTypes.node.isRequired
};
export default AppWrapper;
